import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { captchaValidate, createCaptcha, errorConverter, getContent, getHistory, sentFile } from "../../api";
import { selectChatApiContentVersion, selectChatApiHistoryVersion } from "../../../entities/settings/model";
export var getHistoryThunk = createAsyncThunk('session/getHistory', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var getState, state, apiVersion;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState;
          state = getState();
          apiVersion = selectChatApiHistoryVersion(state);
          _context.next = 5;
          return getHistory(apiVersion);
        case 5:
          return _context.abrupt("return", _context.sent.data);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
export var getContentThunk = createAsyncThunk('content/getContent', /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_, _ref3) {
    var getState, state, apiVersion;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          getState = _ref3.getState;
          state = getState();
          apiVersion = selectChatApiContentVersion(state);
          _context2.next = 5;
          return getContent(apiVersion);
        case 5:
          return _context2.abrupt("return", _context2.sent.data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}());
export var validateCaptchaThunk = createAsyncThunk('captcha/validateCaptcha', /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value, _ref5) {
    var rejectWithValue, _yield$captchaValidat, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          rejectWithValue = _ref5.rejectWithValue;
          _context3.prev = 1;
          _context3.next = 4;
          return captchaValidate(value);
        case 4:
          _yield$captchaValidat = _context3.sent;
          data = _yield$captchaValidat.data;
          return _context3.abrupt("return", data);
        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3["catch"](1);
          return _context3.abrupt("return", rejectWithValue(errorConverter(_context3.t0)));
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 9]]);
  }));
  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}());
export var generateCapthcaThunk = createAsyncThunk('captcha/generateCapthca', /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(value) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return createCaptcha(value);
        case 2:
          return _context4.abrupt("return", _context4.sent.data);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function (_x7) {
    return _ref7.apply(this, arguments);
  };
}());
export var generateFileThunk = createAsyncThunk('file/generateFile', /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(value) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return sentFile(value);
        case 2:
          return _context5.abrupt("return", _context5.sent.data);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function (_x8) {
    return _ref8.apply(this, arguments);
  };
}());